// extracted by mini-css-extract-plugin
module.exports = {"ProjectsWrapper":"projects_ProjectsWrapper__1PNis","Project":"projects_Project__1OCRw"};